"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const qrcode_react_1 = __importDefault(require("qrcode.react"));
const helpers_1 = require("../../../common/helpers/helpers");
const i18n_js_1 = __importDefault(require("i18n-js"));
const DailyViewHelpers_1 = require("./DailyViewHelpers");
const BookingStatus_1 = __importDefault(require("../Other/BookingStatus"));
const useAvailabilities_1 = __importDefault(require("../../hooks/useAvailabilities"));
const useUrlParams_1 = require("../../hooks/useUrlParams");
const Container = styled_components_1.default.div `
  text-align: left;
  color: white;
  mix-blend-mode: difference;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;

  @media (min-width: 1080px) {
    padding: 28px 0;
  }
`;
const Heading3 = styled_components_1.default.h3 `
  font-size: 28px;
  font-weight: 300;
  line-height: 32px;
  margin: 0;
`;
const Heading1 = styled_components_1.default.h1 `
  font-size: 45px;
  line-height: 60px;
  font-weight: 400;
  margin: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Number of lines to show */
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  padding-right: 2rem;
`;
const Heading4 = styled_components_1.default.h4 `
  font-size: 28px;
  margin: 0;
  line-height: 32px;
  font-weight: 400;
  background-color: #ebe7e7cc;
  border-radius: 8px;
  color: #1c1b1b;
  padding: 5px 10px;
`;
const ActivityWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  min-height: 10%;
  align-items: center;
  justify-content: space-between;
`;
const ActivityDetailsWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: ${({ fullWidth }) => (fullWidth ? '80%' : '100%')};
  gap: 5px;

  .status-box {
    color: #1c1b1b;
    background-color: #ebe7e7cc;
  }
`;
const OpenInApp = styled_components_1.default.div `
  font-size: 16px;
  font-weight: 200;
  line-height: 19px;
  text-align: center;
  padding-bottom: 0.5rem;
`;
const QrCodeContainer = styled_components_1.default.div `
  height: 9rem;
  width: 7.5rem;
  border: 1.5vmin solid rgba(0, 0, 0, 0);
  border-radius: 1.2vmin;
  background-color: rgba(0, 0, 0, 0.5);
  padding-bottom: 1rem;
  padding-top: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const TimeAndPlace = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-top: 0.5rem;
`;
const ImageOverlayText = ({ activity, timezone, currentLocale, showQrCode }) => {
    i18n_js_1.default.locale = currentLocale;
    const { start, end, title, deeplink, placeName, locale, contentId, bookable } = activity;
    const { dayAfterTomorrow } = (0, DailyViewHelpers_1.getDates)();
    let headingText = 'Coming next';
    if ((0, DailyViewHelpers_1.isToday)(start)) {
        headingText = i18n_js_1.default.t('DS_daily_view_coming_next', { currentLocale });
    }
    else if ((0, DailyViewHelpers_1.isTomorrow)(start)) {
        headingText = i18n_js_1.default.t('ds_daily_view_coming_tomrrow', { currentLocale });
    }
    else if ((0, DailyViewHelpers_1.isDayAfterTomorrow)(start)) {
        headingText = `${i18n_js_1.default.t('ds_daily_view_coming_on_day', { currentLocale })} ${helpers_1.Helpers.getWeekdayDateAndMonth(dayAfterTomorrow.toString(), timezone)}`;
    }
    const activityTime = (0, DailyViewHelpers_1.renderActivityTime)({ start: start, end: end }, timezone);
    const { brand, venue: urlVenue } = (0, useUrlParams_1.useUrlParams)();
    const availability = (0, useAvailabilities_1.default)({ contentId, locale, bookable }, brand, urlVenue);
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(ActivityWrapper, null,
            react_1.default.createElement(ActivityDetailsWrapper, { fullWidth: !showQrCode },
                react_1.default.createElement(Heading3, null, headingText),
                react_1.default.createElement(Heading1, null, title),
                react_1.default.createElement(TimeAndPlace, null,
                    react_1.default.createElement(Heading4, null, activityTime),
                    placeName && react_1.default.createElement(Heading4, null, placeName)),
                availability && react_1.default.createElement(BookingStatus_1.default, { availabilityState: availability, size: 0.95, currentLocale: locale })),
            !showQrCode && (react_1.default.createElement(QrCodeContainer, null,
                react_1.default.createElement(OpenInApp, null, "Open in App"),
                react_1.default.createElement(qrcode_react_1.default, { value: deeplink, size: 90, className: "qr-code" }))))));
};
exports.default = ImageOverlayText;
